import React, { useEffect, useState } from "react"

import { ProductFields, ToggleButton } from "@tenforce/product-fields"

import { GlobalState } from "../../../../store"
import { useAppDispatch, useAppSelector } from "../../../../hooks"

import { updateField } from "../../slice"
import { fieldsAPI } from "../../../../apis"
import { usePrevious } from "../../../../hooks/usePreviousHook"
import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"
import { IToggleButtonField } from "../../index"

export interface Props {
    field: IToggleButtonField
}

export const ToggleButtonField = ({ field }: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const { isLoading, id } = useAppSelector(
        (state: GlobalState) => state.fields,
    )
    const [selectables, setSelectables] = useState(
        [] as ProductFields.ToggleItem[],
    )
    const [isInitialized, setIsInitialized] = useState(false)
    const {
        position: _position,
        odataType: _odataType,
        value,
        ...fieldProps
    } = field

    const prevValue = usePrevious(value)

    useEffect(() => {
        if (prevValue?.valueId === value?.valueId && isInitialized) {
            return
        }

        fieldsAPI
            .collectSelectableValues(id, field)
            .then((selectables) => setSelectables(selectables))

        if (!isInitialized) {
            setIsInitialized(true)
        }
    }, [value])

    return (
        <ToggleButton
            {...fieldProps}
            description={
                <HTMLAndInternalLinkParser
                    content={(field?.description as string) ?? ""}
                />
            }
            items={selectables}
            isSingleSelect={true}
            isLoading={isLoading}
            onSave={(changedValue: string[]): void => {
                const newValue =
                    changedValue?.length === 0 ? null : changedValue[0]
                dispatch(
                    updateField({
                        field,
                        newValue,
                    }),
                )
            }}
        />
    )
}

export default ToggleButtonField
